module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pageHome.elements) ? _c('div', {
    staticClass: "landing-home"
  }, [_c('hero', {
    attrs: {
      "props": _vm.pageHome.elements,
      "heroHome": true
    }
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "section-block cx2 container-fluid col-xs-12",
    attrs: {
      "id": "section"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\tToo is better than one.\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "col-lg-8 col-lg-offset-2 fade-in"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("Great digital solutions require a combination of strategic thinking, technical skill, UX and analytics prowess to derive and optimize value from the customer journey.")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Marcus Thomas’ digital team adds one more important thing to the mix: we deliver digital solutions that consider your company’s journey, too.")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn_orange gtm_buttonCX2_learnmore_topCTA",
    attrs: {
      "tag": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openJourney()
      }
    }
  }, [_vm._v("DOWNLOAD OUR POV")])])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "section-block  your-journey container-fluid col-xs-12",
    attrs: {
      "id": "your-journey"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\tYour journey is about to begin …\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3 not-gutter"
  }, [_c('form', {
    attrs: {
      "id": "journeyForm",
      "data-vv-scope": "journeyForm",
      "action": "https://crm.zoho.com/crm/WebToLeadForm",
      "name": "WebToLeads3285587000000368027",
      "method": "POST",
      "accept-charset": "UTF-8"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('journeyForm')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "captcha_settings",
      "value": "{\"keyname\":\"Captcha\",\"fallback\":\"true\",\"orgId\":\"00D6A0000038T85\",\"ts\":\"\"}"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "oid",
      "value": "00D6A0000038T85"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "retURL",
      "value": "http://"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Campaign_ID",
      "value": "7013u0000007r6zAAA"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "lead_source",
      "value": "Website"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    class: {
      error: _vm.errors.has('journeyForm.first_name')
    }
  }, [(_vm.journeyForm.first_name === '') ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.journeyForm.first_name),
      expression: "journeyForm.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "first_name",
      "maxlength": "40",
      "name": "first_name",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.journeyForm.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.journeyForm, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('journeyForm.first_name')),
      expression: "errors.has('journeyForm.first_name')"
    }],
    staticClass: "message-error"
  }, [_vm._v(_vm._s(_vm.errors.first('journeyForm.first_name')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6",
    class: {
      error: _vm.errors.has('contactForm.last_name')
    }
  }, [(_vm.journeyForm.last_name === '') ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.journeyForm.last_name),
      expression: "journeyForm.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "last_name",
      "maxlength": "80",
      "name": "last_name",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.journeyForm.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.journeyForm, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('journeyForm.last_name')),
      expression: "errors.has('journeyForm.last_name')"
    }],
    staticClass: "message-error"
  }, [_vm._v(_vm._s(_vm.errors.first('journeyForm.last_name')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    class: {
      error: _vm.errors.has('journeyForm.company')
    }
  }, [(_vm.journeyForm.company === '') ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.journeyForm.company),
      expression: "journeyForm.company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "company",
      "maxlength": "100",
      "name": "company",
      "placeholder": "Company"
    },
    domProps: {
      "value": (_vm.journeyForm.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.journeyForm, "company", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('journeyForm.company')),
      expression: "errors.has('journeyForm.company')"
    }],
    staticClass: "message-error"
  }, [_vm._v(_vm._s(_vm.errors.first('journeyForm.company')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6",
    class: {
      error: _vm.errors.has('journeyForm.email')
    }
  }, [(_vm.journeyForm.email === '') ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.journeyForm.email),
      expression: "journeyForm.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "maxlength": "100",
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.journeyForm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.journeyForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('journeyForm.email')),
      expression: "errors.has('journeyForm.email')"
    }],
    staticClass: "message-error"
  }, [_vm._v(_vm._s(_vm.errors.first('journeyForm.email')))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('vue-recaptcha', {
    staticClass: "captcha",
    attrs: {
      "sitekey": "6LfWNoYsAAAAAPb_D9jpoKajSmdXs6WDQx98RUXd"
    },
    on: {
      "verify": _vm.markRecaptchaAsVerifiedJourney
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "captcha-error"
  }, [_c('p', {
    staticClass: "text-small"
  }, [_vm._v(_vm._s(_vm.journeyForm.pleaseTickRecaptchaMessage))])]), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "section-block performance container-fluid col-xs-12",
    attrs: {
      "id": "performance"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\tPerformance and predictability, too.\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-lg-offset-2"
  }, [_c('p', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v("Proven discovery and definition processes, and best-in-class collaboration and communications tools, ensure development strategy and UX are informed by client and user needs and technology – and that key solutions are tested in the hypothetical stage.")])])]), _vm._v(" "), _c('div', {
    staticClass: "row icons"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-3 col-lg-2 col-lg-offset-2"
  }, [_c('div', {
    staticClass: "inner-icons"
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": "/dist/agile.svg"
    }
  })]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-3 col-lg-2"
  }, [_c('div', {
    staticClass: "inner-icons"
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": "/dist/detail.svg"
    }
  })]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-3 col-lg-2"
  }, [_c('div', {
    staticClass: "inner-icons"
  }, [_c('div', {
    staticClass: "inner-icons"
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": "/dist/ux-test.svg"
    }
  })]), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-3 col-lg-2"
  }, [_c('div', {
    staticClass: "inner-icons"
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": "/dist/collab.svg"
    }
  })]), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-lg-offset-2"
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "partners-container"
  }, [_c('img', {
    attrs: {
      "src": "/dist/mural.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/sketch.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/invision.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/optimal.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/jira.png"
    }
  })])])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contact-form'),
      expression: "'#contact-form'"
    }],
    staticClass: "btn_orange gtm_buttonCX2_letstalk",
    attrs: {
      "tag": "button"
    }
  }, [_vm._v("let's talk")])])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "section-block big-ideas container-fluid col-xs-12",
    attrs: {
      "id": "big-ideas"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\tShouldn’t you expect big execution, too?\n\t\t\t")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "row icons"
  }, [_c('div', {
    staticClass: "col-sm-3 col-lg-2 col-lg-offset-2"
  }, [_c('div', {
    staticClass: "inner-icons"
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": "/dist/ux-design.svg"
    }
  })]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-lg-2"
  }, [_c('div', {
    staticClass: "inner-icons"
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": "/dist/web-mobile-dev.svg"
    }
  })]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-lg-2"
  }, [_c('div', {
    staticClass: "inner-icons"
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": "/dist/crm-market.svg"
    }
  })]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-lg-2"
  }, [_c('div', {
    staticClass: "inner-icons"
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": "/dist/analytics.svg"
    }
  })]), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19)])])]), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('button', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contact-form'),
      expression: "'#contact-form'"
    }],
    staticClass: "btn_orange gtm_buttonCX2_tellusaboutyourjourney",
    attrs: {
      "tag": "button"
    }
  }, [_vm._v("tell us about your journey")])])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "section-block better-than-one container-fluid col-xs-12",
    attrs: {
      "id": "better-than-one"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\tIsn’t it time you got to know us?\n\t\t\t")]), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22)])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "section-block contact-form container-fluid col-xs-12",
    attrs: {
      "id": "contact-form"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\tContact Us\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3 not-gutter"
  }, [_c('form', {
    attrs: {
      "id": "contactForm",
      "data-vv-scope": "contactForm",
      "action": "https://crm.zoho.com/crm/WebToLeadForm",
      "name": "WebToLeads3285587000000345044",
      "method": "POST",
      "accept-charset": "UTF-8"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('contactForm')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "captcha_settings",
      "value": "{\"keyname\":\"Captcha\",\"fallback\":\"true\",\"orgId\":\"00D6A0000038T85\",\"ts\":\"\"}"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "oid",
      "value": "00D6A0000038T85"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "retURL",
      "value": "http://"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Campaign_ID",
      "value": "7013u000000FBMSAA4"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "lead_source",
      "value": "Website"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    class: {
      error: _vm.errors.has('contactForm.first_name')
    }
  }, [(_vm.contactForm.first_name === '') ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.contactForm.first_name),
      expression: "contactForm.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "first_name",
      "maxlength": "40",
      "name": "first_name",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.contactForm.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactForm, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contactForm.First Name')),
      expression: "errors.has('contactForm.First Name')"
    }],
    staticClass: "message-error"
  }, [_vm._v(_vm._s(_vm.errors.first('contactForm.first_name')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6",
    class: {
      error: _vm.errors.has('contactForm.last_name')
    }
  }, [(_vm.contactForm.last_name === '') ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.contactForm.last_name),
      expression: "contactForm.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "last_name",
      "maxlength": "80",
      "name": "last_name",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.contactForm.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactForm, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contactForm.Last Name')),
      expression: "errors.has('contactForm.Last Name')"
    }],
    staticClass: "message-error"
  }, [_vm._v(_vm._s(_vm.errors.first('contactForm.last_name')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    class: {
      error: _vm.errors.has('contactForm.company')
    }
  }, [(_vm.contactForm.company === '') ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.contactForm.company),
      expression: "contactForm.company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "company",
      "maxlength": "100",
      "name": "company",
      "placeholder": "Company"
    },
    domProps: {
      "value": (_vm.contactForm.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactForm, "company", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contactForm.company')),
      expression: "errors.has('contactForm.company')"
    }],
    staticClass: "message-error"
  }, [_vm._v(_vm._s(_vm.errors.first('contactForm.company')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6",
    class: {
      error: _vm.errors.has('contactForm.email')
    }
  }, [(_vm.contactForm.email === '') ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.contactForm.email),
      expression: "contactForm.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "maxlength": "100",
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.contactForm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contactForm.email')),
      expression: "errors.has('contactForm.email')"
    }],
    staticClass: "message-error"
  }, [_vm._v(_vm._s(_vm.errors.first('contactForm.email')))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group checkbox-container col-xs-12"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactForm.check_1),
      expression: "contactForm.check_1"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "check_1",
      "name": "check_1",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.contactForm.check_1) ? _vm._i(_vm.contactForm.check_1, "1") > -1 : (_vm.contactForm.check_1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.contactForm.check_1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.contactForm, "check_1", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.contactForm, "check_1", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.contactForm, "check_1", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "check_1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t        I have an upcoming need I’d like to discuss.\n\t\t\t\t\t\t      ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactForm.check_2),
      expression: "contactForm.check_2"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "check_2",
      "name": "check_2",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.contactForm.check_2) ? _vm._i(_vm.contactForm.check_2, "1") > -1 : (_vm.contactForm.check_2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.contactForm.check_2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.contactForm, "check_2", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.contactForm, "check_2", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.contactForm, "check_2", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "check_2"
    }
  }, [_vm._v("\n\t\t\t\t\t\t        I’d like to schedule a capabilities presentation.\n\t\t\t\t\t\t      ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactForm.check_3),
      expression: "contactForm.check_3"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "check_3",
      "name": "check_3",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.contactForm.check_3) ? _vm._i(_vm.contactForm.check_3, "1") > -1 : (_vm.contactForm.check_3)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.contactForm.check_3,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.contactForm, "check_3", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.contactForm, "check_3", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.contactForm, "check_3", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "check_3"
    }
  }, [_vm._v("\n\t\t\t\t\t\t        Other\n\t\t\t\t\t\t      ")])]), _vm._v(" "), (!_vm.contactForm.checkBoxSelected) ? _c('span', {
    staticClass: "checkbox-message-error"
  }, [_vm._v("Select at least one option")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactForm.description),
      expression: "contactForm.description"
    }],
    staticClass: "track-it",
    attrs: {
      "id": "description",
      "rows": "8",
      "cols": "80",
      "placeholder": "Let’s talk about your journey …",
      "name": "description",
      "maxlength": "32000"
    },
    domProps: {
      "value": (_vm.contactForm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactForm, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('vue-recaptcha', {
    staticClass: "captcha",
    attrs: {
      "sitekey": "6LfWNoYsAAAAAPb_D9jpoKajSmdXs6WDQx98RUXd"
    },
    on: {
      "verify": _vm.markRecaptchaAsVerifiedContact
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "captcha-error"
  }, [_c('p', {
    staticClass: "text-small"
  }, [_vm._v(_vm._s(_vm.contactForm.pleaseTickRecaptchaMessage))])]), _vm._v(" "), _vm._m(24), _vm._v(" "), (_vm.contactForm.formSubmitted) ? _c('div', {
    class: [_vm.contactForm.formSubmitted ? 'thank-message fadeIn' : '']
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "row"
  }, [_vm._m(25)])]) : _vm._e()], 1)])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3 "
  }, [_c('p', {
    staticClass: "text-small"
  }, [_vm._v("* Required fields.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn_orange gtm_buttonCX2_whitepaper_download",
    attrs: {
      "type": "submit",
      "tag": "button"
    }
  }, [_vm._v("Download Whitepaper")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3 subscribe"
  }, [_c('p', {
    staticClass: "text-small"
  }, [_vm._v("By providing us with your information, you may receive occasional updates about Marcus Thomas products and services, as well as invitations to exclusive webinars and events. You can unsubscribe from emails at any time. See our "), _c('a', {
    attrs: {
      "href": "/privacy",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("Agile Planning / Roadmapping")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("Detailed Documentation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("UX Testing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("Collaboration & Communication")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-lg-offset-2"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("Big ideas drive innovation and are essential to engaging customers. Big ideas need big execution, too. That’s why our team is organized and focused on the four areas innovative companies need most:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("User Experience Design")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toggle-icon"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": "/dist/plus.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('ul', [_c('li', [_vm._v("Customer journey map development")]), _vm._v(" "), _c('li', [_vm._v("Experience maps")]), _vm._v(" "), _c('li', [_vm._v("Low- and high-fidelity wireframing")]), _vm._v(" "), _c('li', [_vm._v("Static and functional prototyping")]), _vm._v(" "), _c('li', [_vm._v("Live and web-based UX testing")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("Enterprise Web & Mobile Development")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toggle-icon"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": "/dist/plus.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('ul', [_c('li', [_vm._v("Web and mobile site development")]), _vm._v(" "), _c('li', [_vm._v("Custom web and mobile apps")]), _vm._v(" "), _c('li', [_vm._v("CMS and eCommerce implementation")]), _vm._v(" "), _c('li', [_vm._v("Promotion/content updates, maintenance")]), _vm._v(" "), _c('li', [_vm._v("Outsourcing, staff augmentation and managed services")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("CRM / Marketing Automation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toggle-icon"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": "/dist/plus.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('ul', [_c('li', [_vm._v("Salesforce Marketing Cloud consulting and implementation")]), _vm._v(" "), _c('li', [_vm._v("Salesforce Sales and Service Cloud integrations")]), _vm._v(" "), _c('li', [_vm._v("Third-party CRM integrations (MS Dynamics, Sugar CRM)")]), _vm._v(" "), _c('li', [_vm._v("Custom Salesforce Marketing Cloud apps")]), _vm._v(" "), _c('li', [_vm._v("Custom Salesforce Journey Builder activities")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("Analytics & Performance Optimization")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toggle-icon"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": "/dist/plus.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('ul', [_c('li', [_vm._v("Measurement strategy design")]), _vm._v(" "), _c('li', [_vm._v("Website tracking implementation")]), _vm._v(" "), _c('li', [_vm._v("End-to-end campaign measurement and reporting")]), _vm._v(" "), _c('li', [_vm._v("Cross-channel and multi-touch attribution")]), _vm._v(" "), _c('li', [_vm._v("Custom dashboard development in Tableau and Data Studio")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-lg-offset-2"
  }, [_c('div', {
    staticClass: "partners-container"
  }, [_c('img', {
    attrs: {
      "src": "/dist/kentico.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/sitecore.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/sitefinity.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/salesforce.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/google-cloud.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-lg-offset-2"
  }, [_c('p', {
    staticClass: "text-center text-bold"
  }, [_vm._v("700+ Websites and Mobile Apps  |  50+ Salesforce  Marketing Cloud Implementations  | 72 Experts")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("For more than 20 years, global brands and B2B leaders have called on us to develop and implement digital strategies, launch online ventures, and create or improve their digital marketing initiatives.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-lg-offset-2"
  }, [_c('div', {
    staticClass: "partners-container m25"
  }, [_c('img', {
    attrs: {
      "src": "/dist/troy-bilt.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/fanatics.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/ibm.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/key-bank.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/cu.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/momentive.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/oh-lottery.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/maritz.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/assurant.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/firstenergy.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3 "
  }, [_c('p', {
    staticClass: "text-small"
  }, [_vm._v("* Required fields.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group text-center col-xs-12"
  }, [_c('button', {
    staticClass: "btn_orange gtm_buttonCX2_contactformsubmit",
    attrs: {
      "type": "submit",
      "tag": "button"
    }
  }, [_vm._v("Submit")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-8 col-lg-offset-2"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("Ok, you’ve taken the first step. We’ll get back to you within one business day.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-761c0691","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/CX2.vue
// module id = 1540
// module chunks = 0